export default __webpack_public_path__ + "static/media/icon-folder-open.4fccd24c.svg";